import { RepresentativeDetails, RepAnswerTypes } from '../enums';
import { copyFor } from '../../copy/copy';

// Sometimes an office can fulfill multiple roles (e.g. President is both Haed of Gov & Head of State).
// This determines whether the same rep has multiple roles.
const repEquality = (rep1, rep2) =>
    rep1.fullName === rep2.fullName &&
    rep1.divisionId === rep2.divisionId &&
    rep1.officeName === rep2.officeName &&
    rep1.level === rep2.level;

const uniqueRepsFilter = (rep, ind, arr) => rep === arr.find(r => repEquality(rep, r));

export const relevantRepresentatives = (representativeSearch, repData) => {
    if (
        !repData ||
        !repData.length ||
        !representativeSearch ||
        !representativeSearch.levels ||
        !representativeSearch.roles
    ) {
        return [];
    }

    return repData
        .filter(
            rep =>
                representativeSearch.levels.indexOf(rep.level) !== -1 &&
                representativeSearch.roles.indexOf(rep.role) !== -1
        )
        .filter(uniqueRepsFilter);
};

export const joinEnglish = arr => {
    if (!arr || !arr.length) {
        return '';
    }
    if (arr.length === 1) {
        return arr[0];
    }
    const andWord = ' ' + copyFor('miscellaneous', 'and') + ' ';
    return arr.slice(0, arr.length - 1).join(', ') + andWord + arr[arr.length - 1];
};

export const districtInfo = rep => {
    if (!rep.state) return '';
    if (rep.level === RepresentativeDetails.Level.Country) {
        if (rep.role === RepresentativeDetails.Role.LegislatorLowerBody) {
            return ' (' + rep.state.toUpperCase() + '-' + rep.districtNo + ')';
        }
        if (rep.role === RepresentativeDetails.Role.LegislatorUpperBody) {
            return (
                ' (' +
                rep.partyIdentifier.toUpperCase() +
                '-' +
                rep.state.toUpperCase() +
                ')'
            );
        }
    }
    return '';
};

export const buildCachedAddress = cacheFormData => {
    if (!cacheFormData) return undefined;
    if (
        !cacheFormData.address ||
        !cacheFormData.homeCity ||
        !cacheFormData.stateId ||
        !cacheFormData.postalCode
    )
        return undefined;
    return {
        address: cacheFormData.address,
        homeCity: cacheFormData.homeCity,
        stateId: cacheFormData.stateId,
        postalCode: cacheFormData.postalCode,
        country: cacheFormData.country,
        county: cacheFormData.county,
        streetNo: cacheFormData.streetNo,
        street: cacheFormData.street
    };
};

export const parseVoteSmartCopy = rep => {
    const { answer, answerType, answerYear, detailedAnswer, fullName, question } = rep;
    if (!!answer === false) {
        return `${fullName} did not provide a position on this issue. Information about their position on this question is not currently available from Vote Smart.`;
    } else {
        if (answerType === RepAnswerTypes.unknown) {
            return `${fullName} did not provide a position on this issue. Information about their position on this question is not currently available from Vote Smart.`;
        }

        if (answerType === RepAnswerTypes.research) {
            return `${fullName} refused to address this issue directly, but Vote Smart inferred this issue position based on the candidate’s public statements, voting record, and evaluations from special interest groups. These issue positions are from ${answerYear}. Their likely response to the question "${question}" is ${answer}.`;
        }

        if (answerType === RepAnswerTypes.direct) {
            return `${fullName} addressed this issue directly on Vote Smart’s ${answerYear} Political Courage Test. Their response to the question "${question}" is: ${answer}.`;
        }
        if (answerType === RepAnswerTypes.direct && !!detailedAnswer) {
            return `${fullName} addressed this issue directly on Vote Smart’s ${answerYear} Political Courage Test. Their direct response to the question "${question}" is: ${detailedAnswer}.`;
        }
    }
};
